"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      background: '#fff',
      fontSize: '10px',
      textAlign: 'center',
      color: '#444',
      borderTop: '1px solid #d2d6de',
      padding: '7px 15px',
      '& a': {
        color: palette.primary.main,
        textDecoration: 'none'
      }
    }
  };
}, {
  name: 'Footer'
});
exports.useStyles = useStyles;